package com.upcominds.expedite.dto

import kotlinx.serialization.Serializable

@Serializable
data class ChallengeDTO(
    val id: String,
    val name: String,
    val description: String,
    val imageUrl: String,
    val points: Int,
    val durationMinutes: Long,
    val deadline: String,
    val difficulty: String,
    val type: String,
    val contentId: String? = null,
    val savingsConfig: SavingsChallengeConfigDTO? = null,
    val socialConfig: SocialChallengeConfigDTO? = null,
    val participantsCount: Int = 0,
    val completedCount: Int = 0,
    val isCompleted: Boolean = false,
    val participationStatus: String? = null,
    val isCommunityCompetition: Boolean = false,
    val competitionId: String? = null
)
